import React, { useState, useContext } from "react";
import { GlobalContext } from "../../context/provider";
import numberbeautify from "../../utils/numberbeautify";
import Editbrokemodal from "./editbrokemodal";
import iqd_rounding from "../../utils/iqd_rounding";
import money_rounding from "../../utils/money_rounding";
import moment from "moment/moment";

const Brokelist = () => {
    const { initState, recaller, setrecaller, initDispatch, clear } =
    useContext(GlobalContext);

    const [damage_id,setdamage_id]=useState();
    const [barcode,setbarcode]=useState();
    const [damage_qty,setdamage_qty]=useState();

    const [show,setshow]=useState(false);
  return (
    <div>
        <Editbrokemodal show={show} setshow={setshow} damage_id={damage_id} barcode={barcode} setbarcode={setbarcode} damage_qty={damage_qty} setdamage_qty={setdamage_qty} />
        <div className="bg-white border border-slate-100 rounded-xl shadow-sm overflow-x-auto">
        
          {/* Section Header */}
          <div className="flex items-center justify-between px-6 py-4 border-b border-slate-100">
            <h2 className="text-base font-semibold text-slate-800">لیستی خەساربوو</h2>
          </div>

          {/* Table */}
          <table className="w-full">
            <thead>
              <tr className="bg-slate-50 border-b border-slate-100">
                <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                  ناوی کاڵا
                </th>
                <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                  باڕکۆد
                </th>
                <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                  نرخی کاڵا
                </th>
                <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                  بڕی خەسار
                </th>
                <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                  بەروار
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-50">
                {initState.broke.map((lis)=>(
                    <tr key={lis.damage_id} className="hover:bg-slate-50 transition-colors duration-100 cursor-pointer" onClick={()=>{
                        setdamage_id(lis.damage_id);
                        setbarcode(lis.item_barcode);
                        setdamage_qty(lis.damage_qty);
                        setshow(true);
                    }}>
                        <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                          {lis.item_name}
                        </td>
                        <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                            {lis.item_barcode}
                        </td>
                        <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                            {numberbeautify(iqd_rounding(money_rounding(lis.item_price)))}
                        </td>
                        <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                              {numberbeautify(money_rounding(lis.damage_qty))}
                        </td>
                        <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                            {moment(lis.damage_date).format("YYYY-MM-DD")}
                        </td>
                    </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>
  )
}

export default Brokelist